import React, { FC } from 'react'
import * as yup from 'yup'

import {
    useReactHookForm,
    UseReactHookFormProps,
} from '@docpace/shared-react-hooks/useReactHookForm'
import {
    MuiFormPracticeFileSelect,
} from '@docpace/shared-react-components/MuiFormPracticeFileSelect'
import {
    FormSubmitControls,
} from '@docpace/shared-react-components'
import {
    AppointmentCycleStatsType,
} from '@docpace/shared-ts-types'
import { PracticeFileFragment } from '@docpace/shared-graphql/fragments'

const schema = {
    statsType: yup.mixed<AppointmentCycleStatsType>()
        .oneOf(Object.values(AppointmentCycleStatsType)),
}

export interface AdminUpdateItemFileFormProps
    extends Omit<UseReactHookFormProps, 'schema'> {
    practiceFiles: PracticeFileFragment[]
    name: string
    title: string
    onCancel?: () => any
}

export const AdminUpdateItemFileForm: FC<
    AdminUpdateItemFileFormProps
> = (props) => {
    const {
        onCancel,
        name,
        title,
        practiceFiles,
        ...reactHookProps
    } = props

    const { FormWrapper, formController, submitError, doSubmit } =
        useReactHookForm({
            ...reactHookProps,
            schema,
        })

    const { getValues, setValue } = formController

    return (
        <FormWrapper formComponentProps={{ autoComplete: 'off' }}>
            <div>
                <MuiFormPracticeFileSelect
                    label={title}
                    name={name}
                    practiceFiles={practiceFiles}
                />
                <FormSubmitControls onCancel={onCancel} submitError={submitError} />
            </div>
        </FormWrapper>
    )
}
